'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--EyeWithLine';

var EntypoEyeWithLine = function EntypoEyeWithLine(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M18.5214844,1.4776001C18.131958,1.086853,17.4981079,1.086792,17.1074829,1.477478L1.4785156,17.1084595c-0.390625,0.390625-0.390625,1.0244141,0.0001221,1.4140015c0.390625,0.390686,1.0233765,0.390625,1.4140015-0.000061L18.5214233,2.8916016C18.9121704,2.5009766,18.9121704,1.8682251,18.5214844,1.4776001z M3.1083984,13.4973145l2.5593262-2.5584717C5.5981445,10.6357422,5.5546875,10.3234863,5.5546875,10c0-2.3789062,1.9902344-4.3085938,4.4453125-4.3085938c0.2861328,0,0.5644531,0.0314941,0.8354492,0.081665l1.2021484-1.2016602C11.394043,4.467041,10.7192383,4.4003906,10,4.4003906C3.4394531,4.4003906,0,9.2324219,0,10C0,10.4234619,1.057373,12.0908203,3.1083984,13.4973145z M16.8950195,6.5046387L14.3330078,9.065918C14.4018555,9.3674316,14.4443359,9.6784668,14.4443359,10c0,2.3789062-1.9892578,4.3066406-4.4443359,4.3066406c-0.2839355,0-0.5598145-0.0317383-0.8288574-0.0810547L7.967041,15.4291992C8.609375,15.5330811,9.2827148,15.5996094,10,15.5996094c6.5605469,0,10-4.8339844,10-5.5996094C20,9.5756836,18.9438477,7.9101562,16.8950195,6.5046387z' })
    );
};

exports.default = EntypoEyeWithLine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/EyeWithLine.js
// module id = ./node_modules/react-entypo/lib/entypo/EyeWithLine.js
// module chunks = 2